module.exports = __webpack_public_path__ + "static/printhelsinki-11a40cf5e979cbdfebb6e7fa12dc3044.png";